import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import {
  CHANGE_EMPLOYEE_STATUS_API_URL,
  CHANGE_EMPLOYEE_STATUS_MUTATION_KEY,
  EMPLOYEES_LIST_PERMISSIONS,
  EMPLOYEES_LIST_QUERY_KEY,
} from '@modules/employees/constants';
import { useToastStore } from '@modules/toast/store';

export default function useChangeEmployeeStatusMutation(): IContextMutationResult<void, Error, number> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, number>({
    mutationKey: [CHANGE_EMPLOYEE_STATUS_MUTATION_KEY],
    mutationFn: (id) => fetchPost<void>(
      CHANGE_EMPLOYEE_STATUS_API_URL,
      id,
      {
        urlParams: {
          id,
        },
        permission: EMPLOYEES_LIST_PERMISSIONS.BAN,
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [EMPLOYEES_LIST_QUERY_KEY] });
      displayPresetToast('edited');
    },
  });
}
